import LocalizationItem from './LocalizationItem'

export default LocalizationItem
